import { yupResolver } from "@hookform/resolvers/yup";
import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import useUpdateEffect from "customHooks/useUpdateEffect";
import useTranslation from "next-translate/useTranslation";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { isEmpty } from "../../../utils/isEmpty";
import MolhamButton from "../MolhamButton";
import CommentController from "./CommentController";
type Props = {
  handleCloseAddEditCommentModal: () => void;
  showAddEditCommentModal: boolean;
  content?: string | null;
  onEditCommentSubmit: (data) => void;
  isLoading: boolean;
  isAdd?: boolean;
};
const AddEditCommentModal = ({
  handleCloseAddEditCommentModal,
  showAddEditCommentModal,
  content,
  onEditCommentSubmit,
  isLoading,
  isAdd,
}: Props) => {
  const { t } = useTranslation("common");
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        comment: Yup.string()
          .trim()
          .min(10, t(`comment_min_invalid`))
          .max(250, t(`comment_max_invalid`))
          .required(t(`field_required`)),
      }),
    [t]
  );
  const {
    handleSubmit,
    reset,
    formState: { errors, isDirty, isValid },
    setValue,
    control,
    watch,
  } = useForm<{
    comment: string;
  }>({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  useUpdateEffect(() => {
    if (content) setValue("comment", content, { shouldValidate: true });
  }, [content]);

  const onSubmit = async (data) => {
    try {
      await onEditCommentSubmit(data);
      reset();
    } catch (err) {}
  };

  return (
    <MolhamModalOffcanvas
      show={showAddEditCommentModal}
      onHide={handleCloseAddEditCommentModal}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={`needs-validation ${!isEmpty(errors) ? "invalid" : ""}`}
      >
        <CommentController control={control} name="comment" watch={watch} />
        <MolhamButton
          id={`comment-${isAdd ? "add" : "edit"}-btn}`}
          disabled={!isDirty || !isValid}
          label={isAdd ? t(`add_comment`) : t(`edit_comment`)}
          isLoading={isLoading}
          className="w-100 mb-3 mb-lg-0"
          startIcon={isAdd ? "fe-plus fs-xl" : "fe-edit fs-xl"}
        />
      </form>
    </MolhamModalOffcanvas>
  );
};

export default AddEditCommentModal;
